const breakPoints = {
  smallMobile: '375px',
  mobile: '600px',
  ipad: '768px',
  ipadPro: '1024px',

  notebook: '1200px',
  desktop: '1800px',
};
export default breakPoints;
